"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Context_1 = __importDefault(require("./Context"));
exports.CreditCardCVVInput = function (props) {
    var context = react_1.useContext(Context_1.default);
    return (react_1.default.createElement("div", null,
        props.label && react_1.default.createElement("span", { className: "sq-label" }, props.label),
        react_1.default.createElement("div", { id: context.formId + "-sq-cvv" })));
};
exports.CreditCardCVVInput.defaultProps = {
    label: 'CVV',
};
//# sourceMappingURL=CreditCardCVVInput.js.map